module.exports = __webpack_public_path__ + "img/Tokelau.39087dae.svg";